import { IAction, INotificationAction } from '../../models/action/core';
import { actions } from '../constants/core';
import { Dispatch } from 'react';
import { Log } from 'ng2-logger';

const _logger = Log.create('Spinner-Middleware');

function handleSubmitButtonLoading(spinnerId: string, isDisabled: boolean) {
    const buttonElement: HTMLButtonElement | null = document.getElementById('btn-' + spinnerId) as HTMLButtonElement;
    if (buttonElement) {
        buttonElement.disabled = isDisabled;
    }
}

const SpinnerMiddleware = (store: any) => {
    return (next: Dispatch<IAction>) => {
        return (action: IAction) => {
            const result = next(action);
            if (action.spinnerId) {
                const getSpinnerElement = document.getElementById(action.spinnerId);
                const getSpinnerContentElement = document.getElementById(action.spinnerId + '_Content');
                const getSpinnerContentElementIsFlex = document.getElementById(action.spinnerId + '_Content_Flex');
                if (getSpinnerElement) {
                    const getSpinnerBackgroundElement = getSpinnerElement.parentNode as HTMLDivElement;
                    if (getSpinnerBackgroundElement) {
                        if (action.spinnerType === 'get') {
                            handleSubmitButtonLoading(action.spinnerId, true);
                            getSpinnerElement.style.display = 'block';
                            getSpinnerBackgroundElement.style.opacity = '1';
                            if (getSpinnerContentElement) {
                                getSpinnerContentElement.style.display = 'none';
                            }
                            if (getSpinnerContentElementIsFlex) {
                                getSpinnerContentElementIsFlex.style.display = 'none';
                            }
                        }
                        if (action.spinnerType === 'set') {
                            handleSubmitButtonLoading(action.spinnerId, false);
                            getSpinnerElement.style.display = 'none';
                            getSpinnerBackgroundElement.style.opacity = '1';
                            if (getSpinnerContentElement) {
                                getSpinnerContentElement.style.display = 'block';
                            }
                            if (getSpinnerContentElementIsFlex) {
                                getSpinnerContentElementIsFlex.style.display = 'flex';
                            }
                        }
                    }
                }
            }
            if(action.spinnerIds && action.spinnerIds.length) {
                action.spinnerIds.map((s: string) => {
                    const getSpinnerElement = document.getElementById(s);
                    const getSpinnerContentElement = document.getElementById(s + '_Content');
                    if (getSpinnerElement) {
                        const getSpinnerBackgroundElement = getSpinnerElement.parentNode as HTMLDivElement;
                        if (getSpinnerBackgroundElement) {
                            if (action.spinnerType === 'get') {
                                handleSubmitButtonLoading(s, true);
                                getSpinnerElement.style.display = 'block';
                                getSpinnerBackgroundElement.style.opacity = '1';
                                if (getSpinnerContentElement) {
                                    getSpinnerContentElement.style.display = 'none';
                                }
                            }
                            if (action.spinnerType === 'set') {
                                handleSubmitButtonLoading(s, false);
                                getSpinnerElement.style.display = 'none';
                                getSpinnerBackgroundElement.style.opacity = '1';
                                if (getSpinnerContentElement) {
                                    getSpinnerContentElement.style.display = 'block';
                                }
                            }
                        }
                    }
                });
            }
            return result;
        };
    };
};

export default SpinnerMiddleware;
